import Form from 'react-bootstrap/Form';
import { Field } from 'formik';

const ValidationRadio = ({ name, label, value, ...props }) => {
  return (
    <Field type="radio" name={name} value={value}>
      {({ field, form: { touched, errors } }) => {
        let modified = touched[name];
        let error = errors[name];
        return (
          <>
            <Form.Check
              {...props}
              type="radio"
              label={label}
              {...field}
              style={{ display: 'inline-block', marginRight: '15px', float: 'left' }}
              isInvalid={!!error && modified}
            />
          </>
        );
      }}
    </Field>
  );
};

export default ValidationRadio;
